import React, { Component } from 'react';
import Formulario from './DistribucionCajasForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class DistribucionCajas extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo,leerPeriodoD, 
        vaciar, numeroDistribucion } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        leerPeriodoD(periodo[5], periodo[7]);
        getModulo(periodo[5], periodo[4]);
        vaciar();
        numeroDistribucion();
        localStorage.removeItem('id_detalle_distribucion');
    }
    
    render(){
        const { loader, modulo, periodoD, listarInsumos, registroDistribucion, 
            detalleInsumo, detallePro, eliminarLineaInsumo, numeroDist,
            nuevaLineaInsumo, numeroS, listarInvernaderos, agregarLinea,
            modificarDistribucion, eliminarLinea, existencia } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    periodoD = {periodoD}
                    detalleCon = {detallePro}
                    registroDevolucion = {registroDistribucion}
                    modificarDevolucion = {modificarDistribucion}
                    listarInsumos = {listarInsumos}
                    detalleInsumo = {detalleInsumo}
                    numeroS = {numeroS}
                    listarInvernaderos = {listarInvernaderos}
                    agregarLinea = {agregarLinea}
                    eliminarLinea = {eliminarLinea}
                    nuevaLineaInsumo = {nuevaLineaInsumo}
                    eliminarLineaInsumo = {eliminarLineaInsumo}
                    existencia = {existencia}
                    numeroDist = {numeroDist}
                />
            </LoadMask>
        );
    }
}

export default DistribucionCajas
